// Programmatic integration landing pages (hyper-local Estonian Magento stack).
// Same slug in both languages so SEO.jsx auto-hreflang stays correct.
// To add one: create the `integration_<key>` block in both locale JSON files,
// add an entry here with `published: true`, and add its path to
// scripts/generate-sitemap.js (integrationRoutes). No route changes needed -
// IntegrationPage renders any published slug dynamically.

export const integrationCategories = [
  { id: 'accounting', en: 'Accounting & ERP', et: 'Raamatupidamine ja ERP' },
  { id: 'payments', en: 'Payments', et: 'Maksed' },
  { id: 'shipping', en: 'Shipping & fulfilment', et: 'Transport ja täitmine' },
];

export const integrations = [
  {
    slug: 'magento-merit-aktiva',
    translationKey: 'integration_merit_aktiva',
    proofLink: '/case-studies/erp-middleware',
    category: 'accounting',
    published: true,
  },
  // Planned (unpublished until each has a real, non-thin page):
  // magento-montonio, magento-maksekeskus  → category: 'payments'
  // magento-omniva, magento-smartpost, magento-dpd → category: 'shipping'
  // magento-erply, magento-directo, magento-smartaccounts → category: 'accounting'
];

export const publishedIntegrations = integrations.filter((i) => i.published);
